const selects = new Map();

const updateSelectByElement = el => {
  const select = selects.get(el);
  if (!select) return;
  select.updateSelectText();
};

class Select {
  constructor({ el }) {
    if (el.classList.contains('no-js-required')) return;

    this.el = el;
    if (!this.el.parentElement || !this.el.parentElement.classList.contains('select-wrapper')) {
      const wrapper = document.createElement('div');

      wrapper.classList.add('select-wrapper');
      wrapper.innerHTML(`
        <svg role="img" class="select-dropdown"><use xlink:href="#icon-dropdown"></use></svg>
        <span class="selected-text"></span>
      `);
      this.el.parentNode.insertBefore(wrapper, this.el.nextSibling);
      wrapper.appendChild(this.el);
    }

    this.updateSelectText();

    this.el.addEventListener('change', event => this.updateSelectText(event));

    const addressCountry = document.querySelector('#address-country');

    if (addressCountry) {
      addressCountry.addEventListener('change', () => this.updateSelectText('province'));
    }

    selects.set(this.el, this);
  }

  updateSelectText(select) {
    let target;
    if (select === 'province') {
      target = document.querySelector('#address-province');
    } else {
      target = this.el;
    }

    const newOption = target.options[target.selectedIndex].value || target.querySelector('option').value;

    let prevSibling = target.previousElementSibling;
    let nextSibling = target.nextElementSibling;

    while (prevSibling) {
      prevSibling.innerText = newOption;
      prevSibling = prevSibling.previousElementSibling;
    }

    while (nextSibling) {
      nextSibling.innerText = newOption;
      nextSibling = nextSibling.nextElementSibling;
    }
  }

  unload() {
    this.el.removeEventListener('change', this.updateSelectText);
    selects.delete(this.el);
  }
}

export { Select as default, updateSelectByElement };
